"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var misc_1 = require("@sentry/utils/misc");
var scope_1 = require("./scope");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be incresed when the global interface
 * changes a and new methods are introduced.
 */
exports.API_VERSION = 3;
/**
 * Internal class used to make sure we always have the latest internal functions
 * working in case we have a version conflict.
 */
var Hub = /** @class */function () {
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
  function Hub(client, scope, version) {
    if (scope === void 0) {
      scope = new scope_1.Scope();
    }
    if (version === void 0) {
      version = exports.API_VERSION;
    }
    this.version = version;
    /** Is a {@link Layer}[] containing the client and scope */
    this.stack = [];
    this.stack.push({
      client: client,
      scope: scope
    });
  }
  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client/client.
   * @param args Arguments to pass to the client/frontend.
   */
  Hub.prototype.invokeClient = function (method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    var _a;
    var top = this.getStackTop();
    if (top && top.client && top.client[method]) {
      (_a = top.client)[method].apply(_a, __spread(args, [top.scope]));
    }
  };
  /**
   * Internal helper function to call an async method on the top client if it
   * exists.
   *
   * @param method The method to call on the client/client.
   * @param args Arguments to pass to the client/frontend.
   */
  Hub.prototype.invokeClientAsync = function (method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    var _a;
    var top = this.getStackTop();
    if (top && top.client && top.client[method]) {
      (_a = top.client)[method].apply(_a, __spread(args, [top.scope])).catch(function (err) {
        console.error(err);
      });
    }
  };
  /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   */
  Hub.prototype.isOlderThan = function (version) {
    return this.version < version;
  };
  /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   */
  Hub.prototype.bindClient = function (client) {
    var top = this.getStackTop();
    top.client = client;
    if (top && top.scope && client) {
      top.scope.addScopeListener(function (s) {
        if (client.getBackend) {
          try {
            client.getBackend().storeScope(s);
          } catch (_a) {
            // Do nothing
          }
        }
      });
    }
  };
  /**
   * Create a new scope to store context information.
   *
   * The scope will be layered on top of the current one. It is isolated, i.e. all
   * breadcrumbs and context information added to this scope will be removed once
   * the scope ends. Be sure to always remove this scope with {@link this.popScope}
   * when the operation finishes or throws.
   *
   * @returns Scope, the new cloned scope
   */
  Hub.prototype.pushScope = function () {
    // We want to clone the content of prev scope
    var stack = this.getStack();
    var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
    var scope = scope_1.Scope.clone(parentScope);
    this.getStack().push({
      client: this.getClient(),
      scope: scope
    });
    return scope;
  };
  /**
   * Removes a previously pushed scope from the stack.
   *
   * This restores the state before the scope was pushed. All breadcrumbs and
   * context information added since the last call to {@link this.pushScope} are
   * discarded.
   */
  Hub.prototype.popScope = function () {
    return this.getStack().pop() !== undefined;
  };
  /**
   * Creates a new scope with and executes the given operation within.
   * The scope is automatically removed once the operation
   * finishes or throws.
   *
   * This is essentially a convenience function for:
   *
   *     pushScope();
   *     callback();
   *     popScope();
   *
   * @param callback that will be enclosed into push/popScope.
   */
  Hub.prototype.withScope = function (callback) {
    var scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  };
  /** Returns the client of the top stack. */
  Hub.prototype.getClient = function () {
    return this.getStackTop().client;
  };
  /** Returns the scope of the top stack. */
  Hub.prototype.getScope = function () {
    return this.getStackTop().scope;
  };
  /** Returns the scope stack for domains or the process. */
  Hub.prototype.getStack = function () {
    return this.stack;
  };
  /** Returns the topmost scope layer in the order domain > local > process. */
  Hub.prototype.getStackTop = function () {
    return this.stack[this.stack.length - 1];
  };
  /**
   * Captures an exception event and sends it to Sentry.
   *
   * @param exception An exception-like object.
   * @param hint May contain additional information about the original exception.
   * @returns The generated eventId.
   */
  Hub.prototype.captureException = function (exception, hint) {
    var eventId = this._lastEventId = misc_1.uuid4();
    this.invokeClientAsync('captureException', exception, __assign({}, hint, {
      event_id: eventId
    }));
    return eventId;
  };
  /**
   * Captures a message event and sends it to Sentry.
   *
   * @param message The message to send to Sentry.
   * @param level Define the level of the message.
   * @param hint May contain additional information about the original exception.
   * @returns The generated eventId.
   */
  Hub.prototype.captureMessage = function (message, level, hint) {
    var eventId = this._lastEventId = misc_1.uuid4();
    this.invokeClientAsync('captureMessage', message, level, __assign({}, hint, {
      event_id: eventId
    }));
    return eventId;
  };
  /**
   * Captures a manually created event and sends it to Sentry.
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   */
  Hub.prototype.captureEvent = function (event, hint) {
    var eventId = this._lastEventId = misc_1.uuid4();
    this.invokeClientAsync('captureEvent', event, __assign({}, hint, {
      event_id: eventId
    }));
    return eventId;
  };
  /**
   * This is the getter for lastEventId.
   *
   * @returns The last event id of a captured event.
   */
  Hub.prototype.lastEventId = function () {
    return this._lastEventId;
  };
  /**
   * Records a new breadcrumb which will be attached to future events.
   *
   * Breadcrumbs will be added to subsequent events to provide more context on
   * user's actions prior to an error or crash.
   *
   * @param breadcrumb The breadcrumb to record.
   * @param hint May contain additional information about the original breadcrumb.
   */
  Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
    this.invokeClient('addBreadcrumb', breadcrumb, __assign({}, hint));
  };
  /**
   * Callback to set context information onto the scope.
   *
   * @param callback Callback function that receives Scope.
   */
  Hub.prototype.configureScope = function (callback) {
    var top = this.getStackTop();
    if (top.scope && top.client) {
      // TODO: freeze flag
      callback(top.scope);
    }
  };
  /**
   * For the duraction of the callback, this hub will be set as the global current Hub.
   * This function is useful if you want to run your own client and hook into an already initialized one
   * e.g.: Reporting issues to your own sentry when running in your component while still using the users configuration.
   */
  Hub.prototype.run = function (callback) {
    var oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  };
  return Hub;
}();
exports.Hub = Hub;
/** Returns the global shim registry. */
function getMainCarrier() {
  var carrier = misc_1.getGlobalObject();
  carrier.__SENTRY__ = carrier.__SENTRY__ || {
    hub: undefined
  };
  return carrier.__SENTRY__;
}
exports.getMainCarrier = getMainCarrier;
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  var registry = getMainCarrier();
  var oldHub = registry.hub;
  registry.hub = hub;
  return oldHub;
}
exports.makeMain = makeMain;
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  var registry = getMainCarrier();
  if (!registry.hub || registry.hub.isOlderThan(exports.API_VERSION)) {
    registry.hub = new Hub();
  }
  return registry.hub;
}
exports.getCurrentHub = getCurrentHub;
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 */
function getHubFromCarrier(carrier) {
  if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
    return carrier.__SENTRY__.hub;
  } else {
    carrier.__SENTRY__ = {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
  }
}
exports.getHubFromCarrier = getHubFromCarrier;